import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import WelcomeBanner from "../common/WelcomeBanner";
import React, { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../services/authService";
import "./styles.scss";
import { isEmail } from "../../utils/validators";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLinkSent, setIsLinkSent] = useState(false);
  const navigate = useNavigate();

  const emailChangeHandler = (event: any) => {
    event.preventDefault();
    setEmail(event.target.value);
    setError(false);
  };

  const sendResetLink = () => {
    forgotPassword(email)
      .then(() => {
        setIsLinkSent(true);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        setApiError("Something went wrong!! Please try again");
      });
  };

  const handleSendResetLink = () => {
    const isValidEmail = isEmail(email);
    setError(!isValidEmail);
    if (isValidEmail) {
      setIsLoading(true);
      sendResetLink();
    }
  };

  return (
    <Box component="div" className="forgot-password-container">
      <Box sx={{ my: 1 }}>
        <WelcomeBanner />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Card className="card-container">
          {isLinkSent ? (
            <CardContent className="card-content">
              <Typography className="reset-password-text">Link Sent</Typography>
              <Typography className="reset-password-instructions">
                Please check your email and click the link we sent to reset your
                password
              </Typography>
              <Typography className="resend-link-text">
                Didn’t get an email?{" "}
                <Button
                  variant="text"
                  className="resend-link-button"
                  onClick={sendResetLink}
                >
                  Resend Link
                </Button>
              </Typography>
              <Button
                variant="contained"
                fullWidth
                className="reset-link-button"
                onClick={() => navigate("/login")}
              >
                BACK TO LOGIN
              </Button>
            </CardContent>
          ) : (
            <CardContent className="card-content">
              <Typography className="reset-password-text">
                Reset Password
              </Typography>
              <Typography className="reset-password-instructions">
                Enter your email to get a link to reset your password{" "}
              </Typography>
              <form autoComplete="off">
                <TextField
                  id="outlined-error-helper-text"
                  type="email"
                  inputProps={{ "data-testid": "emailId" }}
                  onChange={emailChangeHandler}
                  value={email}
                  error={error}
                  helperText={error ? "Please enter valid email address" : ""}
                  autoComplete="off"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  className="user-id-input"
                />
                <Typography variant="sFormHelper" className="api-error-message">
                  {apiError ?? ""}
                </Typography>
                <LoadingButton
                  fullWidth
                  variant="contained"
                  data-testid="resetLinkBtn"
                  size="small"
                  className="reset-link-button"
                  disabled={!email}
                  onClick={handleSendResetLink}
                  loading={isLoading}
                >
                  Send Reset Link
                </LoadingButton>
              </form>
              <Button
                fullWidth
                className="back-to-login-button"
                onClick={() => navigate("/login")}
              >
                Back to login
              </Button>
            </CardContent>
          )}
        </Card>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
